export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-960-368208951fcb587a4a2e7904c6e76581.webp";